<template>
  <div class="inside_pages_content_two">
    <div class="inside_pages_right_content">
      <div class="inside_pages_right_form_title">
        <span>
          {{ type == "add" ? "新增安全小组" : "修改安全小组" }}
        </span>
      </div>
      <form class="form-horizontal">
        <div class="form-group">
          <label class="col-sm-2 control-label">小组名称 </label>
          <div class="col-sm-10">
            <input
              type="text"
              v-model.trim="form.securityTeamName"
              class="form-control"
              placeholder="请输入安全小组名称"
            />
          </div>
        </div>
        <div class="form-group options_box">
          <label class="col-sm-2 control-label">组长</label>
          <div class="col-sm-10">
            <el-select
              v-model="teamMemberValue"
              multiple
              collapse-tags
              style="width: 100%;"
              placeholder="请选择组长"
              @change="selectGroupMember"
            >
              <el-option
                v-for="item in userData"
                :key="item.userId"
                :label="item.userName"
                :value="item.userId"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div>
          <div
            class="form-group"
            v-for="(value, key) in form.teamMemberList"
            :key="key"
          >
            <label class="col-sm-2 control-label"></label>
            <div class="col-sm-10">
              <div class="form-group">
                <div class="col-sm-4">
                  <input
                    type="text"
                    class="form-control"
                    :disabled="true"
                    v-model.trim="value.userName"
                  />
                </div>
                <div class="col-sm-8">
                  <label class="col-sm-2 control-label">
                    职责：
                  </label>
                  <div class="col-sm-10">
                    <el-input
                      clearable
                      size="small"
                      @change="contentChangeMember(value)"
                      v-model.trim="value.teamMemberResponsibilities"
                      placeholder="如：水电"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group options_box">
          <label class="col-sm-2 control-label">维修人员</label>
          <div class="col-sm-10">
            <el-select
              v-model="teamLeaderValue"
              multiple
              collapse-tags
              ref="selectRef"
              style="width: 100%;"
              placeholder="请选择维修人员"
              @change="selectGroupLeader"
            >
              <el-option
                v-for="item in userData"
                :key="item.userId"
                :label="item.userName"
                :value="item.userId"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div>
          <div
            class="form-group"
            v-for="(value, key) in form.teamLeaderList"
            :key="key"
          >
            <label class="col-sm-2 control-label"></label>
            <div class="col-sm-10">
              <div class="form-group">
                <div class="col-sm-4">
                  <input
                    type="text"
                    class="form-control"
                    :disabled="true"
                    v-model.trim="value.userName"
                  />
                </div>
                <div class="col-sm-8">
                  <label class="col-sm-2 control-label">
                    维修范围：
                  </label>
                  <div class="col-sm-10">
                    <el-input
                      clearable
                      size="small"
                      @change="contentChangeLeader(value)"
                      v-model.trim="value.teamLeaderResponsibilities"
                      placeholder="如：水电"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="form-group">
      <label class="col-sm-2 control-label"></label>
      <div class="col-sm-10">
        <el-button type="primary" size="mini" @click="addSecurityTeam"
          >确定提交</el-button
        >
        <el-button size="mini" @click="refeashData()">返回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AddOrEditGroup",
  props: {
    type: {
      type: String,
      default: {
        return: "add"
      }
    },
    id: {
      type: String,
      default: {
        return: ""
      }
    },
    defaultData: {
      type: Object,
      default: {
        return: {}
      }
    }
  },
  data() {
    return {
      teamMemberValue: [], //当前选择的组长
      teamLeaderValue: [], //当前选择的后勤人员
      teamMemberList: [], //组长数组
      teamLeaderList: [], //后勤人员数组
      form: {
        type: 2,
        logisticsId: "",
        securityTeamName: "", //小组名称
        teamMemberList: [], //组长
        teamLeaderList: [], //后勤人员  teamLeaderResponsibilities维修范围 userId维修人id
        whetherHiddenGroup: 0
      },
      treeLoading: false,
      defaultProps: {
        children: "children",
        label: "label"
      },
      userData: [],
      oldTeamMemberList: [],
      oldTeamLeaderList: []
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    }
  },
  mounted() {
    this.getTeamList();
    if (this.id) {
      this.form = Object.assign({}, this.defaultData);
      this.teamMemberValue = this.form.teamMemberList.map((item) => {
        return item.userId;
      });
      this.teamLeaderValue = this.form.teamLeaderList.map((item) => {
        return item.userId;
      });

      this.oldTeamMemberList = this.form.teamMemberList || [];
      this.oldTeamLeaderList = this.form.teamLeaderList || [];
    }
  },
  methods: {
    //获取组长-后勤人员数组
    async getTeamList() {
      var params = {
        logisticsId: this.userInfo.eduId,
        userName: "",
        userPhone: ""
      };
      this.treeLoading = true;
      let res = await this.$Http.getPersonnelUsers(params, true);
      if (res.code == 200) {
        let data = res.data || [];
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          for (
            let iindex = 0;
            iindex < this.oldTeamLeaderList.length;
            iindex++
          ) {
            const eelement = this.oldTeamLeaderList[iindex];
            if (eelement.userId == element.userId) {
              element.teamLeaderResponsibilities =
                eelement.teamLeaderResponsibilities;
            }
          }
        }
        this.userData = data;
      } else {
        this.userData = [];
      }
    },
    // 组长选择
    selectGroupMember(val) {
      let selectData = [];
      for (let index = 0; index < this.userData.length; index++) {
        const element = this.userData[index];
        for (let iindex = 0; iindex < val.length; iindex++) {
          const eelement = val[iindex];
          if (element.userId == eelement) {
            selectData.push({
              userId: element.userId,
              userName: element.userName,
              teamMemberResponsibilities:
                element.teamLeaderResponsibilities || ""
            });
          }
        }
      }
      this.form.teamMemberList = selectData;
    },
    // 后勤人员选择
    selectGroupLeader(val) {
      let selectData = [];
      for (let index = 0; index < this.userData.length; index++) {
        const element = this.userData[index];
        for (let iindex = 0; iindex < val.length; iindex++) {
          const eelement = val[iindex];
          if (element.userId == eelement) {
            selectData.push({
              userId: element.userId,
              userName: element.userName,
              teamLeaderResponsibilities:
                element.teamLeaderResponsibilities || ""
            });
          }
        }
      }
      this.form.teamLeaderList = selectData;
    },
    contentChangeMember(val) {
      for (let index = 0; index < this.userData.length; index++) {
        const element = this.userData[index];
        if (element.userId == val.userId) {
          element.teamMemberResponsibilities =
            val.teamMemberResponsibilities || "";
        }
      }
    },
    contentChangeLeader(val) {
      for (let index = 0; index < this.userData.length; index++) {
        const element = this.userData[index];
        if (element.userId == val.userId) {
          element.teamLeaderResponsibilities =
            val.teamLeaderResponsibilities || "";
        }
      }
    },
    // 提交(新增或编辑)
    addSecurityTeam() {
      this.addOrEditSecurityTeam();
    },
    async addOrEditSecurityTeam() {
      var addGroupData = Object.assign({}, this.form);
      if (addGroupData.securityTeamName == "") {
        this.$message({
          type: "warning",
          message: "请输入安全组名称"
        });
        return false;
      }
      if (this.teamMemberValue.length < 1) {
        this.$message({
          type: "warning",
          message: "请先选择组长"
        });
        return false;
      }
      let memberIndex = -1;
      memberIndex = addGroupData.teamMemberList.findIndex((item) => {
        return item.teamMemberResponsibilities == "";
      });
      if (memberIndex > -1) {
        this.$message({
          type: "warning",
          message:
            "请先给" +
            addGroupData.teamMemberList[memberIndex].userName +
            "组长增加职责!"
        });
        return false;
      }
      if (addGroupData.teamLeaderList.length < 1) {
        this.$message({
          type: "warning",
          message: "请先选维修人员"
        });
        return false;
      }
      let index = -1;
      index = addGroupData.teamLeaderList.findIndex((item) => {
        return item.teamLeaderResponsibilities == "";
      });
      if (index > -1) {
        this.$message({
          type: "warning",
          message:
            "请先给维修人员" +
            addGroupData.teamLeaderList[index].userName +
            "增加维修范围"
        });
        return false;
      }
      addGroupData.logisticsId = parseInt(this.userInfo.eduId);
      // addGroupData.teamMemberList = this.teamMemberValue.map((item) => {
      //   return { userId: item };
      // });
      let res;
      if (this.type == "add") {
        let req = {
          type: 2,
          schoolId: Number(this.$store.state.schoolId),
          logisticsId: this.$store.getters.getUserInfo.logisticsId,
          securityTeamName: addGroupData.securityTeamName,
          whetherHiddenGroup: addGroupData.whetherHiddenGroup,
          teamMemberList: addGroupData.teamMemberList,
          teamLeaderList: addGroupData.teamLeaderList
        };
        res = await this.$Http.addTeamCreation(req);
      } else {
        let req = {
          securityTeamId: parseInt(this.id),
          securityTeamName: addGroupData.securityTeamName,
          teamMemberList: addGroupData.teamMemberList,
          teamLeaderList: addGroupData.teamLeaderList
        };
        res = await this.$Http.editTeamCreation(req);
      }
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.messsage
        });
        this.refeashData();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    refeashData() {
      (this.form = {
        schoolId: parseInt(this.$store.state.schoolId),
        securityTeamName: "", //小组名称
        teamMemberList: [], //组长
        teamLeaderList: [] //后勤人员  teamLeaderResponsibilities维修范围 userId维修人id
      }),
        (this.teamMemberValue = []), //当前选择的组长
        (this.teamLeaderValue = []), //当前选择的后勤人员
        this.$emit("goBack");
    }
  },
  watch: {
    id: function(val) {
      this.getTeamList();
      if (val) {
        // 编辑
        this.form = Object.assign({}, this.defaultData);
        this.teamMemberValue = this.form.teamMemberList.map((item) => {
          return item.userId;
        });
        this.teamLeaderValue = this.form.teamLeaderList.map((item) => {
          return item.userId;
        });
        this.oldTeamMemberList = this.form.teamMemberList || [];
        this.oldTeamLeaderList = this.form.teamLeaderList || [];
      }
    }
  }
};
</script>
<style scoped lang="scss">
.el-tree {
  width: 100%;
  display: inline-block;
  overflow-y: auto;
  overflow-x: scroll;
  overflow: auto;
  max-height: 200px;
}
</style>
